import { render } from "./Main.vue?vue&type=template&id=e491efe8"
const script = {}
script.render = render

export default script